import { RootState } from 'store/rootReducer';

export const campaignsData = (state: RootState) => state.Campaign.campaigns;

export const campaignsDataIsLoading = (state: RootState) => state.Campaign.campaigns.isLoading;

export const botTimezoneData = (state: RootState) => state.Bot.data.bot_timezone;
